import './index.css';
export default function PulseAnimation({ state }) {
    return (
        <div className="pulse">
            <div className="act"></div>
            <div className={`act ${state && 'pulse-1'}`}></div>
            <div className={`act ${state && 'pulse-2'}`}></div>
            <div className={`act ${state && 'pulse-3'}`}></div>
            <div className={`act ${state && 'pulse-4'}`}></div>
            <div className={`act ${state && 'pulse-5'}`}></div>
            <div className="act"></div>
        </div>
    );
}